module.exports = __webpack_public_path__ + "img/pr-1.e2521b95.png";